"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TRANSITIONS = [
    'webkitTransitionEnd',
    'msTransitionEnd',
    'oTransitionEnd',
    'otransitionend',
    'transitionend',
];
class Swipe {
    constructor(container, options) {
        this.containerInfo = {};
        this.slideTimeout = 0;
        this.onTransitionEnd = () => {
            const { current, slides } = this.slideInfo;
            this.slideInfo.isInAinmation = false;
            this.options.onSlideEnd(current, slides[current]);
        };
        this.container = container;
        this.options = this.getOptions(options);
        this.slideInfo = this.getSlideInfo();
        this.setup();
        this.addEventListener();
    }
    addEventListener() {
        const { container } = this;
        TRANSITIONS.forEach((event) => {
            container.addEventListener(event, this.onTransitionEnd);
        });
    }
    removeEventListener() {
        const { container } = this;
        TRANSITIONS.forEach((event) => {
            container.removeEventListener(event, this.onTransitionEnd);
        });
    }
    getOptions(options) {
        return Object.assign({ direction: 1 /* order */, continuous: false, speed: 300, orientation: 1 /* horizen */, onSlide: (_index, _slide) => noop(), onSlideEnd: (_index, _slide) => noop(), startIndex: 0, width: 0, height: 0, interval: 0 }, options);
    }
    getSlideInfo() {
        const { container, options } = this;
        const { children: slides } = container.children[0];
        const isHorizen = options.orientation === 1 /* horizen */;
        const wrapSize = container.getBoundingClientRect()[isHorizen ? 'width' : 'height']
            || container[`offset${isHorizen ? 'Width' : 'Height'}`];
        const originLength = slides.length;
        const slideSize = options.width || wrapSize;
        const slideDataList = [...slides].map((ele, i) => i * slideSize);
        return {
            originLength,
            slides: [...slides],
            current: options.startIndex,
            slideDataList,
            slideSize,
            isInAinmation: false,
        };
    }
    setup() {
        this.resetPosition();
        this.start();
    }
    // 获取 指定偏移的实际索引，支持负数
    getCircleIndex(offset) {
        const { length } = this.slideInfo.slides;
        return (length + offset % length) % length;
    }
    resetPosition() {
        const { slides, slideSize } = this.slideInfo;
        const { startIndex, direction, onSlide } = this.options;
        // console.log('[reset position]: ', slideSize);
        slides.forEach((_slide, i) => {
            const offset = slideSize * (i - startIndex) * direction;
            // console.log('[reset position]: ', i, offset, 0);
            this.translate(i, offset, 0);
        });
        onSlide.apply(this, [startIndex, slides[startIndex]]);
    }
    translate(index, offset, speed) {
        const { slideInfo } = this;
        const { orientation } = this.options;
        const slider = slideInfo.slides[index];
        const translateValue = orientation === 1 /* horizen */ ? `${offset}px, 0px, 0px` : `0px, ${offset}px, 0px`;
        if (!slider) {
            return;
        }
        translate(slider, {
            transform: `translate3d(${translateValue})`,
            transitionDuration: `${speed}ms`,
            zIndex: index === slideInfo.current ? 1 : 0,
        });
    }
    move(index, offset, slideSpeed) {
        this.translate(index, offset, slideSpeed);
        this.slideInfo.slideDataList[index] = offset;
    }
    slide(toIndex, slideSpeed = this.options.speed) {
        const { slideInfo } = this;
        const { current: currentIndex, slideSize } = slideInfo;
        const { direction, onSlide } = this.options;
        // if (currentIndex === toIndex) {
        //   return;
        // }
        this.slideInfo.isInAinmation = true;
        const targetIndex = this.getCircleIndex(toIndex);
        // console.log('[slide]: ', targetIndex, slideSpeed);
        slideInfo.slides.forEach((_slide, i) => {
            const offset = slideSize * (i - targetIndex) * direction;
            // 非相邻 slide 不需要过渡动画
            const speed = Math.abs(i - targetIndex) > slideSize ? 0 : slideSpeed;
            // console.log('move: ', i, offset, speed);
            this.move(i, offset, speed);
        });
        slideInfo.current = targetIndex;
        onSlide.apply(this, [targetIndex, slideInfo.slides[targetIndex]]);
    }
    start() {
        const { interval } = this.options;
        if (!interval) {
            return;
        }
        clearTimeout(this.slideTimeout);
        this.slideTimeout = window.setTimeout(() => {
            this.slide(this.slideInfo.current + this.options.direction);
            this.start();
        }, interval);
    }
    stop() {
        clearTimeout(this.slideTimeout);
    }
    next() {
        this.slide(this.slideInfo.current + 1);
    }
    prev() {
        this.slide(this.slideInfo.current - 1);
    }
    resize() {
        const { container, options } = this;
        const isHorizen = options.orientation === 1 /* horizen */;
        const sizeName = isHorizen ? 'Width' : 'Height';
        const wrapSize = container.getBoundingClientRect()[sizeName.toLowerCase()]
            || container[`offset${sizeName}`];
        const slideSize = options[sizeName.toLowerCase()] || wrapSize;
        this.slideInfo.slideSize = slideSize;
        this.resetPosition();
    }
    destroy() {
        this.stop();
        this.removeEventListener();
    }
}
exports.default = Swipe;
function noop() { }
;
function translate(element, config) {
    const { style } = element;
    if (!style) {
        return;
    }
    Object.keys(config).forEach((CSSProperty) => {
        style[CSSProperty] = config[CSSProperty];
    });
}
